import { useTranslation } from "react-i18next";
import { formatNumber } from "../utils/nutritionFormat.ts";
import { noWrap } from "../styles/shared.styles.ts";

type MeasurementUnit = { readonly id: string; readonly code: string };

type QuantityUnitDisplayProps = {
  readonly quantity: number | null | undefined;
  readonly unitId: string | null | undefined;
  readonly units: readonly MeasurementUnit[];
};

export const QuantityUnitDisplay = ({ quantity, unitId, units }: QuantityUnitDisplayProps) => {
  const { i18n } = useTranslation();

  if (quantity == null) return null;

  const unit = unitId != null ? units.find((u) => u.id === unitId) : undefined;
  return (
    <span className={noWrap}>
      {formatNumber(quantity, i18n.language)} {unit?.code}
    </span>
  );
};
